// extracted by mini-css-extract-plugin
export var chevron = "_k4-2";
export var dropdownItems = "_k4-0";
export var item = "_k4-1";